
// new file for common js for restructured and cleaned up contents
// the goal is to move the scripts into separate descriptive files
// which are combined into larger single file with the build process
"use strict";

var openRevealPopups_new = [];
var contentReloadNeeded  = false;
var modalTemplate        = $("#ajaxShowFormTemplate");

function initializeRecaptcha(container, key)
{
    if (container.find(".recaptcha_form_input").length > 0) {
        if (typeof grecaptcha === "undefined") {
            $.getScript("https://www.recaptcha.net/recaptcha/api.js?render="+key, function() {
                grecaptcha.ready(function() {
                    initializeRecaptchaElements(container, key);
                });
            });
        }
        else {
            initializeRecaptchaElements(container, key);
        }
    }
}

function initializeRecaptchaElements(container, key)
{
    container.find(".recaptcha_form_input").each(function() {
        var recaptchaInput = $(this);
        grecaptcha.execute(key, {action: recaptchaInput.attr('id')}).then(function(token) {
            recaptchaInput.val(token);
        });
    });

    /*
    if ($(".recaptcha_form_input").length > 0) {
        $.getScript("https://www.recaptcha.net/recaptcha/api.js?render={{recaptcha_site_key}}", function() {
            grecaptcha.ready(function() {
                $(".recaptcha_form_input").each(function() {
                    var recaptchaInput = $(this);
                    grecaptcha.execute('{{ recaptcha_site_key }}', {action: recaptchaInput.attr('id')}).then(function(token) {
                        recaptchaInput.val(token);
                    });
                });
            });
        });
    }
    */
}

/**
 * Function to delete all the hidden reveal popups in queue
 */
function ajaxFoundationPopup_empty()
{
    while (openRevealPopups_new.length > 0) {
        $(openRevealPopups_new.pop()).remove();
    }
}

/**
 * Function to open Foundation reveal for specific url
 *
 * @param {String}  url
 * @param {Object}  reloadData
 * @param {Array}   formData - optional parameter
 * @param {Boolean} cors
 * @param {Boolean} openMultipleModal
 */
function ajaxFoundationPopup_new(url, reloadData, formData, cors, openMultipleModal = false)
{ 
    var id = "ajaxShowForm_" + (Math.floor(Math.random() * 90000) + 10000);
    var fullId = "#"+id;

    // reveal modal already open, close that and store it in the popup array
    for (var i = 0; i < openRevealPopups_new.length; i++) {
        var openRevealPopup = $(openRevealPopups_new[i]);
        openRevealPopup.hide();
    }

    // clone and add the new modal to dom
    var modal = modalTemplate.clone();
    modal.attr("id", id);
    modal.addClass("ajaxShowForm");
    $('body').append(modal);

    // define the modal parameters
    var params = {
        url: url,
        success: function(data) {
        },
        error: function() {
            openRevealPopups_new.pop();
            $(fullId).remove();
        }
    };

    if (cors) {
        params = $.extend({
            xhrFields: {
                withCredentials: true
           }
        }, params);
    }

    if (typeof formData !== 'undefined') {
        params = $.extend({
            data: formData,
            method: 'POST'
        }, params);
    }

    openRevealPopups_new.push(fullId);
    $(fullId).foundation('reveal', 'open', params);

    $(document).on('closed.fndtn.reveal', fullId, function () {
        //$(".reveal-modal-bg").show();
        $("body").css("cursor", "wait");
    });
    
    $(document).on('closed.fndtn.reveal', fullId, function () {
        //$(".reveal-modal-bg").show();
        if (!openMultipleModal) {
            var openRevealPopup = openRevealPopups_new.pop();
            $(openRevealPopup).remove();
        }

        if (openRevealPopups_new.length > 0) {
            var openRevealPopup = openRevealPopups_new[openRevealPopups_new.length - 1];
            $(openRevealPopup).show();
            $("body").css("cursor", "default");
        } else if (contentReloadNeeded && reloadData) {
            if (Array.isArray(reloadData.url)) {
                for (let index in reloadData.url) {
                    ajaxCallReloadData(reloadData.url[index], reloadData.callback)
                }
            } else {
                ajaxCallReloadData(reloadData.url, reloadData.callback)
            }
        } else {
            //$(".reveal-modal-bg").hide();
            $("body").css("cursor", "default");
        }
    });
}

/**
 * Function to call simple ajax and reload data
 *
 * @param {String} url
 * @param {String} callback
 */
function ajaxCallReloadData(url, callback) {
    $.ajax({
        url     : url,
        method  : 'POST',
        success : function(result) {
            contentReloadNeeded = false;
            callback(result);
            $("body").css("cursor", "default");
        }
    });
}

/**
 * Function to call simple ajax callup directly
 *
 * @param {String} url
 * @param {Object} reloadData
 * @param {Bool}   cors
 */
function ajaxSimpleCallupDirect_new(url, reloadData, cors) {
    var params = {
        url    : url,
        method : 'POST',
    };

    if (cors) {
        params = $.extend({
            xhrFields: { 
                withCredentials: true 
            }
        }, params);
    }

    $.ajax(
        $.extend({
            success: function(result) {
                if (result.content_reload_needed && reloadData) { 
                    if (reloadData.url) {
                        $.ajax({
                            url     : reloadData.url,
                            method  : 'POST',
                            success : function(result) {
                                reloadData.callback(result);
                                contentReloadNeeded = false;
                                $("body").css("cursor", "default");
                            }
                        });
                    }
                    else if (reloadData.containerDiv && result.responseView) {
                        var containerDiv = $("#"+reloadData.containerDiv);
                        containerDiv.replaceWith(result.responseView);
                    }
                }
                else {
                    //location.reload();
                }
            }
        }, params)
    );
}

function ajaxSimpleCallup_new(url, reloadData, cors, data) {
    // specific confirmation url
    if (undefined !== data.confirmurl) {
        $.ajax({
            url   : data.confirmurl,
            method: 'POST',
            success: function(result) {
                // success with default confirmation message
                if (result.allowed && !result.showDialog) {
                    confirmFoundationDialog_new(data, function() {
                        removeGenericEntity_new(url, reloadData);
                    });
                }
                // success but non-default confirmation message
                else if (result.allowed && result.showDialog) {
                    confirmFoundationDialog_new(result, function() {
                        removeGenericEntity_new(url, reloadData);
                    });
                }
                // operation is not allowed with explicit message
                else {
                    errorFoundationDialog_new(result);
                }
            }
        });
    }
    // use generic confirmation data from html element
    else {
        confirmFoundationDialog_new(data, function() {
            ajaxSimpleCallupDirect_new(url, reloadData, cors);
        });
    }
}

function removeGenericEntity_new(url, reloadData) {
    $.ajax({
        url    : url,
        method : 'POST',
        success: function(result) {
            if (result.success) {
                if (typeof result.content_reload_needed !== 'undefined') {
                    contentReloadNeeded = (contentReloadNeeded || result.content_reload_needed);
                }

                if (contentReloadNeeded && reloadData) {
                    $.ajax({
                        url     : reloadData.url,
                        method  : 'POST',
                        success : function(result) {
                            contentReloadNeeded = false;
                            reloadData.callback(result);
                            //$(".reveal-modal-bg").hide();
                            $("body").css("cursor", "default");
                        }
                    });
                }
            }
            else {
                confirmFoundationMessage("ERROR", result.message);
                //errorFoundationDialog_new(result);
            }
        }
    });
}

function confirmFoundationDialog_new(data, callback, editMode = true) {
    var modal = $("#confirmationDialog-new");

    modal.find("#confirmationDialog-new__title").html(data.title);
    modal.find("#confirmationDialog-new__message").html(data.text);
    modal.find("button.primary").html(data.confirmtext ? data.confirmtext : 'Delete');
    modal.find("button.secondary").html(data.canceltext ? data.canceltext : 'Cancel');
    if (editMode) {
        modal.find("#confirmationDialog-new__title").addClass("edit-mode");
        modal.find("button.primary").addClass("edit-mode");
        modal.find("button.secondary").addClass("edit-mode");
    }

    modal.off('click');
    modal.foundation('reveal', 'open');

    modal.on('click', '.yes', function() {
        if (null !== callback) {
            callback.call();
        }
        $('#confirmationDialog-new').foundation('reveal','close');
    });

    modal.on('click', '.no', function() {
        $('#confirmationDialog-new').foundation('reveal','close');
    });
}

function errorFoundationDialog_new(data, callback) {
    var modal = $("#errorDialog-new");

    modal.find("#errorDialog-new__title").html(data.title);
    modal.find("#errorDialog-new__message").html(data.text);

    modal.off('click');
    modal.foundation('reveal', 'open');

    modal.on('click', '.button', function() {
        $('#errorDialog-new').foundation('reveal','close');
    });
}

function autocompleteEmails(inputDom, emailsPathReference) {
    var emailPath = emailsPathReference;

    $(inputDom).autocomplete({
        minLength: 4,
        source: function( request, response ) {
            var term = request.term;
            var searchPath = emailPath.replace(/__term__/g, term);

            $.ajax({
                url: searchPath,
                method: 'GET',
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    var emails = [];
                    $.each(data, function (i) {
                        if (data[i].email.toLowerCase().indexOf(term.toLowerCase()) != -1) {
                            emails.push({label: data[i].email, value: data[i].email});
                        }
                    });
                    response(emails.slice(0, 30));
                }
            })
        }
    });
}

function autocompletePotentialMembers(potentialMembersPath) {
    var potentialMembers = potentialMembersPath;

    $("#submission_assignment_potentialMembers").autocomplete({
        minLength: 3,
        source: function( request, response ) {
            var term = request.term;
            var searchPath = potentialMembers.replace(/__term__/g, term);

            $.ajax({
                url: searchPath,
                method: 'GET',
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    if (!data.length) {
                        var result = [
                            {
                                label: 'No results found',
                                value: ''
                            }
                        ];

                        response(result);
                    } else {
                        var emails = [];
                        $.each(data, function (i) {
                            var displayValue = data[i].firstName + " " + data[i].lastName + ", " + data[i].email;
                            var displayLabel = data[i].firstName + " " + data[i].lastName + ", " + data[i].email + " (" + data[i].personType + ")";

                            emails.push({label: displayLabel, value: displayValue});
                        });

                        response(emails.slice(0, 10));
                    }
                }
            })
        },
        select: function (event, ui) {
            if ('No results found' !== ui.item.value) {
                var detachedData = ui.item.value.split(",");
                var detachedFirstLastName = detachedData[0].split(" ");

                $("#submission_assignment_firstName").val(detachedFirstLastName[0]);
                $("#submission_assignment_lastName").val(detachedFirstLastName[1]);
                $("#submission_assignment_email").val(detachedData[1].trim()).trigger("input");
            } else {
                $("#submission_assignment_firstName").val('');
                $("#submission_assignment_lastName").val('');
                $("#submission_assignment_email").val('');
            }
        },
    });
}

// method for handling url with string instead parameter
function handleEditPath(object, event, url) {
    event.preventDefault();
    if (!object.hasClass("disabled")) {
        url = url.replace(/__hashkey__/g, object.closest("tr").data('hash'));

        return url;
    }

    return false;
}

function filterSubmissionsTable(section) {
    var stringFilter = $(".search-filter-input").val().toLowerCase();
    var statusFilter = $("#status-filters li.active").data("statusid");

    if (null === statusFilter) {
        statusFilter = "null";
    }

    let statuses = statusFilter.toString().split(', ');
    let classes = [];
    $.each(statuses, function (index, value) {
        classes.push('status-' + value);
    });

    $(".string-filter").each(function(e) {
        if (-1 === $(this).find(".search-tags").data("tags").toLowerCase().indexOf(stringFilter)) {
            $(this).addClass('string-filter-hidden');
        } else {
            $(this).removeClass('string-filter-hidden');
        }
    });

    $(".status-filter").each(function(e) {
        if (!$(this).hasClasses(classes)) {
            $(this).addClass('status-filter-hidden');
        } else {
            $(this).removeClass('status-filter-hidden');
        }
    });

    if (section) {
        var sectionFilter = $("#section-filter").val();

        $(".section-filter").each(function(e) {
            if ("0" !== sectionFilter && sectionFilter != $(this).data("section")) {
                $(this).addClass('section-filter-hidden');
            } else {
                $(this).removeClass('section-filter-hidden');
            }
        });

        if ("0" !== sectionFilter) {
            $("#section-chairs").show();
        }
    }

    $(document).foundation('equalizer', 'reflow');
}

function updateStatusCounts(element, section) {
    $.each($("#status-filters li"), function(index, value) {
        if (section) {
            var sectionId = $("#section-filter").val();
        }

        let containerDiv = element;
        if ("object" === $.type(element)) {
            containerDiv = element.tablediv;
        }

        let status = $(value).data('statusid');
        let submissionCount = 0;

        if ("string" === $.type(status)) {
            let statuses = status.split(', ');
            $.each(statuses, function(key, statusid) {
                submissionCount += $(containerDiv + " tr.status-filter.status-"+statusid + (section ? (".section-filter.section-"+sectionId) : "")).length;
            });
        } else {
            submissionCount = $(containerDiv + " tr.status-filter.status-"+status + (section ? (".section-filter.section-"+sectionId) : "")).length;
        }

        $("#status-filters li[data-statusid='" + status + "'] span").html(submissionCount);
    });
}

$.fn.extend({
    hasClasses: function (classes) {
        var self = this;
        for (var i in classes) {
            if ($(self).hasClass(classes[i]))
                return true;
        }
        return false;
    }
});

function validateFormInputs() {
    $(document).on('input', ':input', function(e) {
        if ($(this).hasClass('error')) {
            $(this).removeClass('error');

            $(this).parent().parent().find('small.error').hide();
            $(this).css('margin-bottom', '1rem');

            $(this).parent().next('div.error').hide();
        }
    });
}

function removeErrorMessage(inputId) {
    let tinymceField = $("#" + inputId);
    tinymceField.parent().parent().find('small.error').hide();

    if (tinymceField.hasClass('error')) {
        tinymceField.removeClass('error');
        tinymceField.prev('div').removeClass('error');
        tinymceField.parent().next('div.error').hide();
    }

    if ("" !== tinymceField.parent().find('.macro-row-edit__actions__error').html()) {
        tinymceField.parent().find('.macro-row-edit__actions__error').hide();
    }
}

function initializeOwlCarousel() {
    $('.owl-carousel').owlCarousel({
        loop: false,
        rewind: true,
        margin: 10,
        responsiveClass: true,
        nav: true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1000: {
                items: 4
            }
        }
    });
}

function increasePaperReads(domElement) {
    $(domElement).on("click", ".read_url", function (e) {
        e.preventDefault();

        let obj = $(this);
        let url = '/elastic/show_stats';
        let data = {
            identifier: obj.data('identifier')
        };

        let that = this;
        let targetWindow = window.open(obj.attr('href'), '_blank');
        targetWindow.onload = () => {
            $.ajax({
                type: "POST",
                url: url,
                dataType: 'json',
                data: {data: data},
                success: function (result) {
                    if (result) {
                        var parentItemBox = $(that).closest('.papers-item-box');
                        parentItemBox.find(".read-data").html(result + " Reads");
                    }
                },
                error: function (data, textStatus, jqXHR) {
                    console.log('Something happened wrong ');
                }
            });
        }

    });
}

function initializeUploadFile() {
    $(document).on('change', '.file-upload', function (e) {
        e.preventDefault();
        $(this).parent().find(".remove-file-input-ajax").trigger('click'); //Delete the resource exists initially
        let that = this;
        let imageFile = $(this).get(0).files[0];
        let fileUrl = window.URL.createObjectURL(imageFile);
        if (imageFile.type.indexOf('image') !== -1) {
            let msg = `<div class="upload-thumb">&nbsp;&nbsp;
                            <a href="${fileUrl}" data-lightbox="image-${fileUrl}" class="file-thumb">
                                <img src="${fileUrl}" width="40px" height="40px"  alt=""/>
                            </a>
                            <a class="remove-file-thumb" href="#">
                                <i class="fa fa-times"></i>
                            </a>
                        </div>`
            if ($(that).hasClass("cropper-file-input")) {
                $(".submitImageCropperModal").on('click', function (e) {
                    $(that).parent().find(".upload-thumb, .file-thumb, .remove-file-input-ajax").remove();
                    $(that).next().append(msg);
                });
                $(".closeImageCropperModal").on('click', function (e) {
                    msg = '';
                });
            } else {
                $(that).parent().find(".upload-thumb, .file-thumb, .remove-file-input-ajax").remove();
                $(that).next().append(msg);
            }
        } else {
            let msg = `<div class="upload-file">&nbsp;&nbsp;
                        <a href="${fileUrl}" target="_blank" class="file-thumb">
                            <i class="fa fa-download"></i>
                        </a>
                        <a class="remove-file-thumb" href="#">
                            <i class="fa fa-times"></i>
                        </a>
                    </div>`
            $(that).parent().find(".upload-file, .file-thumb, .remove-file-input-ajax").remove();
            $(that).next().append(msg);
        }
    })

    $(document).on('click', '.remove-file-thumb', function (e) {
        e.preventDefault();
        $(this).parent().parent().parent().find(":input").val('');
        $(this).parent().remove();
    })
}

function filterEventTypes() {
    $(".js-type-link").on('click', function(e) {
        e.preventDefault();
        if (!$(this).hasClass("disabled")) {
            var parentRow = $(this).closest(".row");
            var previousActiveContainer = parentRow.find(".event-listing-container:visible");
            var newActiveContainer = parentRow.find("." + $(this).data("type")).show();

            previousActiveContainer.hide();
            closeList(previousActiveContainer);
            newActiveContainer.show();

            if (parentRow.hasClass("toggled")) {
                toggleList(newActiveContainer, false);
            }
        }
    });
}

function closeList(listingContainer) {
    var link = listingContainer.find(".listing-more-link");
    var span = link.find("span");

    listingContainer.find(".js__box-toggle").hide();
    span.html("MORE");
}

/**
 * Retrieves the value of a specified parameter from a given URL.
 *
 * @param {string} url - The URL containing the parameters.
 * @param {string} paramName - The name of the parameter to retrieve.
 */
function getUrlParams(url, paramName) {
    if (url.split('?')[1] === undefined) {
        return null;
    }
    let urlStr = url.split('?')[1]
    let obj = {};
    let paramsArr = urlStr.split('&')
    for (let i = 0, len = paramsArr.length; i < len; i++) {
        let arr = paramsArr[i].split('=')
        obj[arr[0]] = arr[1];
    }
    return obj[paramName];
}

/**
 * Function to update the parameters with the specified url
 *
 * @param url
 * @param paramName
 * @param paramValue
 */
function replaceUrlParam(url, paramName, paramValue) {
    if (paramValue == null || paramValue === '') {
        //delete the specified parameter
        return url.replace(new RegExp('[?&]' + paramName + '=[^&#]*(#.*)?$'), '$1').replace(new RegExp('([?&])' + paramName + '=[^&]*&'), '$1');
    }

    var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
    if (url.search(pattern) >= 0) {
        return url.replace(pattern, '$1' + paramValue + '$2');
    }
    url = url.replace(/[?#]$/, '');

    return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
}

function loadPaging(url, elem, countUrl = undefined, callback = undefined) {
    changePaging(elem, callback);
    searchWithPaging(elem, callback);
    statusFilters(url, countUrl, elem, callback);
    updateStatusCountsByAjax(countUrl);
    sortTable(url, elem)
}

function loadPagingResult(url, elem, callback) {
    $.ajax({
        type: "POST",
        url: url,
        dataType: 'json',
        success: function (result) {
            $("#" + elem).html(result.responseView);
            $(document).foundation('equalizer', 'reflow');
            sortTable(url, elem);
            if(undefined !== callback) {
                callback.call();
            }
        },
        error: function (data, textStatus, jqXHR) {
            console.log('Something happened wrong ');
        }
    });
}

function changePaging(elem, callback) {
    $(document).on('click', '#' + elem + ' .paging a', function (e) {
        e.preventDefault();
        let search = $(".ajax-search-filter-input").val();
        let url = replaceUrlParam($(this).data('params'), 'search', search);
        loadPagingResult(url, elem, callback);
    })
}

function searchWithPaging(elem, callback) {
    $(document).on("keyup", ".ajax-search-filter-input", function (e) {
        let container = $(this).data('container');
        if(undefined !== container && elem !== container) {
            return false;
        }
        let url = $("#" + elem + " #paging-param").data("params");
        let searchUrl = replaceUrlParam(url, 'search', $(this).val());
        searchUrl = replaceUrlParam(searchUrl, 'page', null);
        loadPagingResult(searchUrl, elem, callback);
    });
}

function statusFilters(url, countUrl, elem, callback) {
    $(document).on('change', '#section-filter', function (e) {
        e.preventDefault();
        let updateCountUrl = replaceUrlParam(countUrl, 'sessionId', $(this).val());
        let searchUrl = replaceUrlParam(url, 'sessionId', $(this).val());
            searchUrl = replaceUrlParam(searchUrl, 'search', $(".ajax-search-filter-input").val());
        updateStatusCountsByAjax(updateCountUrl);
        loadPagingResult(searchUrl, elem, callback);
    });

    $(document).on('click', '#status-filters li', function (e) {
        e.preventDefault();
        $("#status-filters li").removeClass("active");
        $(this).addClass("active");
        let url = $("#" + elem + " #paging-param").data("params");
        let searchUrl = replaceUrlParam(url, 'statusId', $(this).data('statusid'));
        searchUrl = replaceUrlParam(searchUrl, 'page', null);
        loadPagingResult(searchUrl, elem);
    });
}

function updateStatusCountsByAjax(url){
    if (undefined === url){
        return;
    }

    $.ajax({
        type: "POST",
        url: url,
        dataType: 'json',
        success: function (result) {
            $.each($("#status-filters li"), function(index, value) {
                let status = $(value).data('statusid');
                let submissionCount = 0;

                if ("string" === $.type(status)) {
                    let statuses = status.split(', ');
                    $.each(statuses, function(key, statusid) {
                        submissionCount += result.submissionsCounts[statusid] !== undefined ? result.submissionsCounts[statusid] : 0;
                    });
                } else {
                    submissionCount = result.submissionsCounts[status] !== undefined ? result.submissionsCounts[status] : 0;
                }

                $("#status-filters li[data-statusid='" + status + "'] span").html(submissionCount);
            });
        },
        error: function (data, textStatus, jqXHR) {
            console.log('Something happened wrong ');
        }
    });
}

function sortTable(url, elem) {
    let sortTableEle = $('.ajax-table-sorter');
    // Check if the table element is empty
    if ($("#" + elem + " tbody tr").length === 0 || sortTableEle.length === 0) {
        return false;
    }

    // Initialize variables for sorting
    let sortList = {sortColumn: 0, sortType: 0};
    let sortableElements = $(".ajax-table-sorter thead th.sortable");
    let sortHeaders = {};

    // Iterate over sortable elements to determine sorting parameters
    $.each(sortableElements, function (key, data) {
        if ($(data).data('sort') === getUrlParams(url, 'sortField') && undefined !== $(data).data('sort')) {
            sortList.sortColumn = key;
        }

        if (null === getUrlParams(url, 'sortField') && ($(data).hasClass('headerSortUp') || $(data).hasClass('headerSortDown'))) {
            sortList.sortColumn = key;
            sortList.sortType = $(data).hasClass('headerSortUp') ? 1 : 0;
        }

        if ($(data).hasClass('sorter-false')) {
            sortHeaders[key] = {sorter: false};
        }
    })

    // Update sortType if sortField parameter exists in the URL
    if (null !== getUrlParams(url, 'sortField')) {
        sortList.sortType = getUrlParams(url, 'sortType') === 'asc' ? 1 : 0;
    }

    // Sort the table using the tablesorter plugin
    sortTableEle.tablesorter({
        selectorHeaders: 'thead th.sortable',
        sortList: [[sortList.sortColumn, sortList.sortType]],
        headers: sortHeaders,
        textExtraction: function (node) {
            return null;
        }
    })

    // Add click event listener to sortable elements
    sortableElements.on('click', function () {
        let sortType = $(this).hasClass("headerSortDown") ? 'asc' : 'desc';
        let sortField = $(this).data('sort');
        let url = $("#" + elem + " #paging-param").data("params");
        let searchUrl = replaceUrlParam(url, 'sortField', sortField);
        searchUrl = replaceUrlParam(searchUrl, 'sortType', sortType);
        loadPagingResult(searchUrl, elem);
    })
}

/**
 * Attaches event handlers to a checkbox group.
 *
 * @param {string} parentEle - The selector for the parent element of the checkbox group.
 * @param {string} childEle  - The selector for the child elements of the checkbox group.
 */
function checkboxGroup(parentEle, childEle) {
    // Event handler for the parent checkbox
    $(document).on('change', parentEle + ' .checkbox-collection', function (e) {
        let checked = $(this).prop('checked');

        // Check/uncheck all child checkboxes
        $(this).closest(".row").parents(".row").next("div").find("input[type='checkbox']").each(function () {
            $(this).prop('checked', checked);
        });
    });

    // Event handler for the child checkboxes
    $(document).on('change', childEle + ' input[type="checkbox"]', function (e) {
        if (!$(this).hasClass("checkbox-collection")) {
            let parentEle = $(this).closest(".row").parents(".row").parent();

            // Uncheck the parent checkbox if any child checkbox is unchecked
            parentEle.prev("div").find(".checkbox-collection").prop('checked', false);

            // Check the parent checkbox if all child checkboxes are checked
            if(parentEle.find("input[type='checkbox']:checked").length === parentEle.children('div').length){
                $(this).parents(".row").parent().prev("div").find(".checkbox-collection").prop('checked', true);
            }
        }
    });
}

function forbidScholars(){
    $(document).on('change', 'input[name="submission_assignment[email]"]', function (e) {
        let emailAddress = $("#submission_assignment_email").val();
        let submitAjaxModal = $('.submit-ajax-modal');

        if (authorsEmails.includes(emailAddress)) {
            submitAjaxModal.off('click');
            let isSameEmail = 0;
            for (let counter = 0; counter < authorsEmails.length; counter++) {
                let author = authorsEmails[counter];
                if (author === emailAddress) {
                    isSameEmail++;
                }
            }
            if (isSameEmail > 0) {
                submitAjaxModal.on('click', function () {
                    e.preventDefault();
                    submitAjaxModalHandler(submitAjaxModal);
                });
            }
        } else if (!externalEditorsEmails.includes(emailAddress)) {
            submitAjaxModal.off('click');
            let isSameDomain = 0;
            for (let counter = 0; counter < authorsEmailsWithoutLinked.length; counter++) {
                let author = authorsEmailsWithoutLinked[counter];
                let domain = author.substring(authorsEmailsWithoutLinked[counter].lastIndexOf("@") +1);
                let index = emailAddress.indexOf(domain);
                if (index > -1 && author !== emailAddress) {
                    isSameDomain++;
                    submitAjaxModal.on('click', function () {
                        let popupMessage = new Object();
                        popupMessage.title = 'Are you sure you want to continue?';
                        popupMessage.text = 'Warning <br> Same email domain with author: ' + author;
                        popupMessage.confirmtext = 'Submit';
                        popupMessage.canceltext = 'Cancel';
                        confirmFoundationDialog_new(popupMessage, function() {
                            submitAjaxModalHandler(submitAjaxModal)
                            $(".submit-ajax-modal").trigger("click");
                            submitAjaxModal.closest(".ajaxShowForm").find('.close-reveal-modal').trigger('click');
                            $('#confirmationDialog-new').foundation('reveal','close');
                        }, false);
                    });
                    break;
                }
            }

            if (isSameDomain === 0) {
                submitAjaxModal.on('click', function () {
                    e.preventDefault();
                    submitAjaxModalHandler(submitAjaxModal);
                });
            }
        }
    });
}
